<template lang="html">
  <b-container>
    <!-- Coupon -->
    <b-row v-if="$store.getters.show_coupon_offer" class="mb-5 mt-2">
      <b-col>
        <div class="alert alert-info col-10 offset-1 text-center">
          <p class="mb-1 mt-2">
            During the beta period, the new editor is free to use.
          </p>
          <p>
            Subscribe before our official 3.0 launch on
            <strong>August 21st</strong> and you'll receive
            <strong>30% off</strong>.
            <router-link :to="{ name: 'upgrade_view', params: {} }">
              See pricing.
            </router-link>
          </p>
        </div>
      </b-col>
    </b-row>

    <TrialMessage
      v-if="$store.state.user_doc.loaded && $store.getters.is_trial"
    />
    <UpgradeMessage
      v-if="$store.state.user_doc.loaded && !$store.getters.is_trial"
    />

    <!-- Quick start header -->
    <b-row
      v-show="showQuickStartEditor && $store.state.user_show_index_loaded"
      class="mb-3"
    >
      <!-- Example show. -->
      <b-col md="4">
        <b-card
          title="Demo show"
          img-src="https://cdn3.soundslides.com/images/d38LFQBz/400/1556829093104__mg_7718.jpg"
          img-alt="Image"
          img-top
          tag="article"
          style="max-width: 20rem;"
          class="mb-2"
        >
          <b-card-text>
            <p>
              Get your feet wet by importing a classic demo Soundslides project
              into your account.
            </p>
          </b-card-text>

          <b-button
            variant="primary"
            @click="
              demoTriggered = true;
              $store.dispatch('showCreation/forkShowById', 'd38LFQBz');
            "
          >
            Add demo show
          </b-button>
        </b-card>
      </b-col>
      <b-col md="8" class="mb-2 p-3">
        <h3>Welcome to the Soundslides Editor</h3>
        <p class="lead">Create a new show or import an existing show.</p>
        <b-btn
          variant="primary"
          size="lg"
          :disabled="restrictShowCreation"
          @click="$store.dispatch('showCreation/newShow')"
        >
          Create new show <v-icon name="plus" />
        </b-btn>

        <b-btn
          variant="dark"
          size="lg"
          class="ml-2"
          :disabled="restrictShowCreation"
          @click="$store.dispatch('showCreation/newShowForImport')"
        >
          Import show <v-icon name="file-import" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- / Quick start header -->

    <b-row v-show="shows.length > 0">
      <b-col>
        <b-btn
          v-show="!showQuickStartEditor"
          variant="primary"
          size="lg"
          class="mb-4"
          :disabled="restrictShowCreation"
          @click="$store.dispatch('showCreation/newShow')"
        >
          Create new show <v-icon name="plus" />
        </b-btn>

        <b-btn
          v-show="!showQuickStartEditor"
          variant="dark"
          size="lg"
          class="mb-4 ml-2"
          :disabled="restrictShowCreation"
          @click="$store.dispatch('showCreation/newShowForImport')"
        >
          Import show <v-icon name="file-import" />
        </b-btn>

        <div class="float-right mt-3">
          Viewing {{ $store.state.showList.orderedShows.length }} of
          {{ $store.state.user_show_total }} shows
        </div>
      </b-col>
    </b-row>
    <div class="mt-3">
      <ShowsListItem
        v-for="show in $store.state.showList.orderedShows"
        :key="'show_' + show.key"
        :index_show_obj="show"
      />
    </div>
  </b-container>
</template>

<script>
import filter from "lodash/filter";
import sortBy from "lodash/sortBy";
import reverse from "lodash/reverse";
import map from "lodash/map";
import remove from "lodash/remove";
import ShowsListItem from "@/components/ShowsListItem";
import TrialMessage from "@/components/TrialMessage";
import UpgradeMessage from "@/components/UpgradeMessage";
export default {
  name: "Shows",
  components: {
    ShowsListItem,
    TrialMessage,
    UpgradeMessage
  },
  data() {
    return {
      perPage: 6,
      currentPage: 1,
      showQuickStartEditorLimit: 3,
      demoTriggered: false
    };
  },
  computed: {
    shows() {
      var editor_shows = filter(this.$store.state.user_show_index, (s, k) => {
        if (k.startsWith("editor_shows") && !s.deleted) {
          return s;
        }
      });
      var keys_in_editor_shows = map(this.$store.state.editor_shows, "key");
      // Remove the duplicates from the index list.
      editor_shows = remove(editor_shows, s => {
        return !keys_in_editor_shows.includes(s.key);
      });
      // Add the bound (detailed) version of the shows to index list.
      var combined_show_list = editor_shows.concat(
        this.$store.state.editor_shows
      );
      return reverse(sortBy(combined_show_list, "updated_at"));
    },
    rows() {
      return this.shows.length;
    },
    numPages() {
      return Math.ceil(this.rows / this.perPage);
    },
    userHasDemoShow() {
      return (
        filter(this.shows, { fork_history_array: ["d38LFQBz"], deleted: false })
          .length > 0
      );
    },
    showQuickStartEditor() {
      if (this.userHasDemoShow) {
        return false;
      }
      if (this.demoTriggered) {
        return false;
      }
      return this.shows.length < this.showQuickStartEditorLimit;
    },
    showItems() {
      const items = this.shows;
      // Return just page of items needed
      return items.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    restrictShowCreation() {
      return (
        this.$store.getters.restrictShowCreation ||
        this.$store.state.showCreationInProgress
      );
    }
  },
  mounted() {
    /*
    Temporary redirect for new users (as of Sept 28, 2020) to the v4 version.
    

    // Check to see if the user qualifies to be bumped to the v4 app.
    console.log("Temporary check for redirect to v4 interface.");
    var user_doc = this.$store.state.user_doc;
    var DATETIME_FOR_REDIRECT_TO_V4 = 1585494545000; // March, 29th
    console.log(user_doc.created_at);
    if (
      user_doc.created_at >= DATETIME_FOR_REDIRECT_TO_V4 &&
      user_doc.v3_override != true
    ) {
      // Redirect to the new version.
      console.log(window.location.hostname);
      if (window.location.hostname == "soundslides-stage.firebaseapp.com") {
        location.href = "https://soundslides-stage.firebaseapp.com/v4/";
      } else if (window.location.hostname == "127.0.0.1") {
        console.warn("Redirecting would go here.");
      } else {
        location.href = "https://app.soundslides.com/v4/";
      }
    }

    /*
    End of temporary redirect for new users.
    */

    this.$store.dispatch("setBowserInitial");
    this.$store.dispatch("showList/loadShowNext");
  },
  methods: {
    image(show) {
      if (show.firstImage) {
        return `https://cdn3.soundslides.com/images/${show.firstImage.source_id}/400/${show.firstImage.file}`;
      } else {
        return null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.thumb {
}
</style>
